import { useQuery } from '@tanstack/react-query';
import { getAutomation, getAutomations } from '../automation';

export function useAutomations() {
  return useQuery({
    queryKey: ['automations'],
    queryFn: () => getAutomations(),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}

export function useAutomation(id: string) {
  return useQuery({
    queryKey: ['Automation', id],
    queryFn: () => getAutomation(id),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}